import React from 'react';
import './styles.css';





export const AnaAyudanteDerecha = () => {


  return (
    <>


        <div className='AnaAyudanteDerecha-Container'>

            <div className='AnaAyudanteDerecha-nombre-texto-container'>
                
                <div className='AnaAyudanteDerecha-nombre' />

                <div className='AnaAyudanteDerecha-texto'>

                      <div className='AnaAyudanteDerecha-texto-subcontainer'>
                          Maestra de Educación Infantil y Primaria. 
                          Directora Educativa de la escuela, y profesora 
                          de música en todos los niveles.
                      </div>
                      
                </div> 

            </div>

            <div className='AnaAyudanteDerecha-maestra' />

        </div>


    </>
  )
}
